import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PropertyBookingsWorkspaceService } from '../../../services/property-bookings-workspace.service';

@Component({
  selector: 'app-builder-workspace-picker-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './builder-workspace-picker-modal.component.html',
})
export class BuilderWorkspacePickerModalComponent {
  protected readonly workspace = inject(PropertyBookingsWorkspaceService);

  onDialogCancel(event: Event): void {
    event.preventDefault();
    this.workspace.cancelModal();
  }

  onBackdropClick(): void {
    this.workspace.cancelModal();
  }
}
